import type { AugmentedStore } from '@model/vue-store/augmented-store';

export default {
    namespaced: true,

    state: () => ({
        items: [],
    }),

    actions: {
        async getCountries(this: AugmentedStore, store) {
            const countries = await this.$context.Synced.countries.getList();
            store.commit('setCountries', countries);
        },
    },

    mutations: {
        setCountries(state, countries) {
            state.items = countries;
        },
    },
};
